import { render, staticRenderFns } from "./ItemProcessing.vue?vue&type=template&id=24519de4&scoped=true"
import script from "./ItemProcessing.vue?vue&type=script&lang=js"
export * from "./ItemProcessing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24519de4",
  null
  
)

export default component.exports